module.exports = __webpack_public_path__ + "static/media/pending-action.0edf15fc.svg";